import React, {useState} from 'react';
import Row from "../../UI/Row";
import SubscriptionRadio from "../../PurchaseSteps/SubscriptionRadio";
import subscriptions from "../../../utilities/data/products";
import Button from "../../UI/Button";
import ProductsDescriptionBanner from "../../Registration/ProductsDescriptionBanner";
import CheckTermsAndCondition from "../../UI/CheckTermsAndCondition";
import ErrorMessage from "../../UI/ErrorMessage";

const SubscriptionSelect = ({subscription, onSelect}) => {

    const [selected, setSelected] = useState(subscription ?? subscriptions.base);
    const [readTerms, setReadTerms] = useState(false);
    const [error, setError] = useState(false);

    const purchaseClick = () => {
        if(readTerms)
        onSelect && onSelect(selected);
        else
            setError("Conferma l'accettazione dei Termini e delle Condizioni");
    }

    const handleTermChange = (value) => {
        if(value) {
            setError("");
        }
        setReadTerms(value);
    }

    return (
        <div>
            <div className="text-center text-black mb-8">
                <ProductsDescriptionBanner showTrial={false}/>
            </div>
            <Row className="w-full justify-around mb-8">
                <SubscriptionRadio name="BASE"
                                   selected={selected.id === subscriptions.base.id || selected.id === subscriptions.trial_base.id}
                                   subscription={subscriptions.base}
                                   onClick={() => setSelected(subscriptions.base)}/>
                <SubscriptionRadio name="dinamico"
                                   selected={selected.id === subscriptions.dynamic.id || selected.id === subscriptions.trial_dynamic.id}
                                   subscription={subscriptions.dynamic}
                                   onClick={() => setSelected(subscriptions.dynamic)}
                                   bgColor="ea_green_from"
                                   textColor="white"/>
            </Row>

            <CheckTermsAndCondition className="mb-4 justify-center" value={readTerms} onChange={handleTermChange} />
            {error && <ErrorMessage className="text-center mb-4">{error}</ErrorMessage>}

            <Row className="justify-center">
                <Button onClick={purchaseClick} disabled={!readTerms} className="text-black">Procedi all'acquisto</Button>
            </Row>
            <div className="text-sm mt-2 text-center text-gray-400">(Se hai già un abbonamento attivo il nuovo abbonamento avrà validità dalla fine del periodo dell'abbonamento corrente)</div>
        </div>
    );
};

export default SubscriptionSelect;